import { render, staticRenderFns } from "./canvasWindow.vue?vue&type=template&id=af2d97c0&"
import script from "./canvasWindow.vue?vue&type=script&lang=ts&"
export * from "./canvasWindow.vue?vue&type=script&lang=ts&"
import style0 from "./canvasWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports